import { IDictionary } from 'util/domain';
import { CommonUtilsService } from 'util/services';
import {
	PhoenixUser, 
	PendingUser,
	UserStatistic
} from 'phoenix/domain';
import { 
	User,
	TypedDataStore
} from 'sharebase/domain';
import UsersService from 'sharebase/services/usersService';
/**
* @ngdoc service
* @name  sharebase.sbUsersDataStore
* 
* @description 
* A datastore used to retrieve ShareBase users
**/
export default class UsersDataStore implements TypedDataStore<User[]>{
	public static $inject = [
		'$q',
		'$filter',
		'utils',
		'sbUsersService'
	];

	public users:User[] = [];
	private orderBy:ng.IFilterOrderBy;
	 
	private _pendingUsers:PendingUser[] = [];
	get pendingUsers() { 
		return this._pendingUsers; 
	}

	constructor(
		private $q:ng.IQService,
		$filter:ng.IFilterService, 
		private utils:CommonUtilsService,
		private sbUsersService:UsersService
	) {
		this.orderBy = $filter('orderBy');
	}

	/**
	* @ngdoc method
	* @name sbUsersDataStore#getUsers
	* @methodOf sharebase.sbUsersDataStore
	* @kind function
	*
	* @description
	* Gets a collection of users
	*
	* @returns {Deferred} A promise that will resolve with a collection of users
	* 
	*/
	public load(systemName?:string) {
		return this.$q
			.all([
				this.sbUsersService.getUsers(systemName, false),
				this.sbUsersService.getDiskUsageByUser(systemName),
				this.sbUsersService.getDocumentsStoredByUser(systemName)
			])
			.then(resp => {
				let docsStored = this.utils.arrayToDict(resp[1], stat => stat.UserId.toString());
				let fileUsage = this.utils.arrayToDict(resp[2], stat => stat.UserId.toString());
				let statsByUser:IDictionary<IDictionary<UserStatistic>> = resp[0].reduce((statsByUser, user) => {
					let combined  = this.combineStatsForUser(user.UserId,  [
						docsStored,
						fileUsage
					]);
					
					if(Object.keys(combined).length > 0){
						statsByUser[user.UserId] = combined;
					}

					return statsByUser;
				}, {} as IDictionary<IDictionary<UserStatistic>>)
				this.users = this
					.orderBy(resp[0], 'UserName')
					.map(user => new User(user, statsByUser[user.UserId]));

				return this.users;
			});
	}

	private combineStatsForUser(userId:number, stats:IDictionary<UserStatistic>[]){
		return stats.reduce((userStats, statCategory) => {
			let stat = statCategory[userId];
			if(stat){
				userStats[stat.Id] = stat;
			}
			return userStats
		}, {});
	}
	/**
	* @ngdoc method
	* @name sbUsersDataStore#getPendingUsers
	* @methodOf sharebase.sbUsersDataStore
	* @kind function
	*
	* @description
	* Gets a collection of pending users
	*
	* @returns {Deferred} A promise that will resolve with a collection of pending users
	* 
	*/
	public getPendingUsers() {
		return this.sbUsersService
			.getPendingUsers()
			.then(response => {
				this._pendingUsers = this.orderBy(response, 'EmailAddress');
				return response;
			});
	}

	public resendInvitation(pendingUser:PendingUser) {
		return this.sbUsersService
			.resendInvitation(pendingUser)
			.then(res => res);
	}

	public changePendingUserEmail(pendingUser:PendingUser, email:string) {
		return this.sbUsersService
			.changePendingUserEmail(pendingUser, { EmailAddress: email })
			.then(res => {
				this._pendingUsers.forEach(user => {
					if (user.EmailAddress === pendingUser.EmailAddress) {
						user.EmailAddress = email;
					}
				});
				return res;
			});
	}	

	public clearStore(){
		this.users = [];
		this._pendingUsers = [];
	}
}


// WEBPACK FOOTER //
// ./src/sharebase/dataStores/usersDataStore.ts